// Copyright (c) 2016 Deere & Company

import StatesInCountry, {getDefaultState} from '../state/states-in-country';
import actions from '../../actions-list';

const updateStatesInCountry = (state, action) =>
    StatesInCountry.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_STATES_IN_COUNTRY_SUCCESS]: updateStatesInCountry
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/status-change-request/reducers/states-in-country.js